<template>
  <div class="t-app__container">
    <heading :overTitle="$t('business-dashboard-overTitle')" :title="$t('business-dashboard-title')" :text="$t('business-dashboard-text')" />
    <div class="h-section h-section--small-top">
      <dashboard-tabs />
      <div v-if="displaySubscriptionMessage">
        <p v-if="haveNoBusiness" class="participate-dashboard__warning" v-html="$t('featured-product-no-business-text')"></p>
        <p v-else-if="haveNotRegisteredBusiness" class="participate-dashboard__warning" v-html="$t('featured-product-not-registered-business-text')"></p>
        <p v-else class="participate-dashboard__success" v-html="$t('featured-product-all-registered-business-text')"></p>
      </div>
      <dashboard-section :title="$t('dashboard-participate-business-title')">
        <business-list v-if="myBusiness.length > 0" :value="myBusiness" :entrepreneurs="myEntrepreneurs" />
        <p>
          <button class="a-btn-primary" @click="createBusiness">{{ $t('create-business-btn') }}</button>
        </p>
      </dashboard-section>
      <hr />
      <dashboard-section :title="$t('dashboard-participate-entrepreneur-title')">
        <entrepreneur-list :value="myEntrepreneurs" @entrepreneurUpdated="onEntrepreneurUpdated" />
        <p>
          <button class="a-btn-primary" @click="showAddEntrepreneurPanel">{{ $t('create-entrepreneur-btn') }}</button>
        </p>
        <div class="o-panel" v-if="isAddEntrepreneurPanelOpen" v-bind:class="{ 'o-panel--open': isAddEntrepreneurPanelOpen }">
          <div class="o-panel__head">
            <h2 class="o-panel__title">{{ $t('dashboard-participate-entrepreneur-add-title') }}</h2>
            <button type="button" class="o-panel__close" @click="hideAddEntrepreneurPanel">{{ $t('panel-close') }}</button>
          </div>
          <div class="o-panel__content">
            <add-entrepreneur @onEntrepreneurAdded="onEntrepreneurAdded" />
          </div>
        </div>
        <div class="o-panel__overlay" @click="hideAddEntrepreneurPanel"></div>
      </dashboard-section>
      <hr />
      <dashboard-section v-if="haveActiveBusiness" :title="$t('dashboard-participate-toolbox-title')">
        <link-list :value="participateToolboxLinks" />
      </dashboard-section>
    </div>
  </div>
</template>

<script>
import router from '@/router'
import { URL_CREATE_BUSINESS } from '@/consts/urls'

import Heading from '@/components/heading'
import DashboardTabs from '@/components/dashboard/dashboard-tabs'
import BusinessList from '@/components/dashboard/business/business-list'
import EntrepreneurList from '@/components/dashboard/entrepreneur-list'
import LinkList from '@/components/dashboard/link-list'
import DashboardSection from '@/components/dashboard/dashboard-section'
import AddEntrepreneur from '@/components/form/add-entrepreneur'

import LoaderService from '@/services/loader'
import BusinessService from '@/services/business'
import EntrepreneurService from '@/services/entrepreneur'
import NotificationService from '@/services/notification'

import { EventBus } from '@/helpers/event-bus.js'
import i18n from '@/helpers/i18n'

export default {
  components: {
    Heading,
    DashboardTabs,
    BusinessList,
    EntrepreneurList,
    LinkList,
    DashboardSection,
    AddEntrepreneur
  },
  data() {
    return {
      myBusiness: [],
      myEntrepreneurs: [],
      isAddEntrepreneurPanelOpen: false,
      displaySubscriptionMessage: false
    }
  },
  mounted() {
    let vm = this

    EventBus.$on('subscribe-paid', async () => {
      LoaderService.showLoader()
      // On laisse le temps à snipcart de caller notre webhook et qu'on update notre table Business avant de
      // rafraichir les entreprises pour voir les boutons modifier au lieu de inscrire
      setTimeout(async function() {
        vm.myBusiness = await BusinessService.getMyBusiness()
        LoaderService.hideLoader()
        NotificationService.showSuccess(i18n.t('subscribe-paid'))
      }, 5000)
    })
  },
  computed: {
    participateToolboxLinks: function() {
      return this.$store.getters.participateToolboxLinks
    },
    haveActiveBusiness: function() {
      return this.myBusiness.filter(x => x.IsRegistered).length > 0
    },
    haveNoBusiness: function() {
      return this.myBusiness.length === 0
    },
    haveNotRegisteredBusiness: function() {
      return this.myBusiness.filter(x => !x.IsRegistered).length > 0
    }
  },
  methods: {
    showAddEntrepreneurPanel: function() {
      this.isAddEntrepreneurPanelOpen = true
    },
    hideAddEntrepreneurPanel: function() {
      this.isAddEntrepreneurPanelOpen = false
    },
    createBusiness() {
      router.push({ name: URL_CREATE_BUSINESS })
    },
    onEntrepreneurAdded: async function() {
      this.isAddEntrepreneurPanelOpen = false
      await this.refreshEntrepreneurList()
    },
    refreshEntrepreneurList: async function() {
      this.myEntrepreneurs = await EntrepreneurService.getMyEntrepreneurs()
    },
    onEntrepreneurUpdated: async function() {
      await this.refreshEntrepreneurList()
    }
  },
  async beforeRouteEnter(to, from, next) {
    LoaderService.showLoader()

    let myBusiness = await BusinessService.getMyBusiness()
    let myEntrepreneurs = await EntrepreneurService.getMyEntrepreneurs()

    next(vm => {
      vm.myBusiness = myBusiness
      vm.myEntrepreneurs = myEntrepreneurs

      if (vm !== undefined) {
        vm.displaySubscriptionMessage = vm.haveNotRegisteredBusiness === true || vm.haveNoBusiness === true || to.query.isFromFeaturedProduct !== undefined
      }

      LoaderService.hideLoader()
    })
  }
}
</script>
<style lang="scss">
.participate-dashboard {
  &__warning {
    border: 2px solid #edb539;
    margin: 20px 0;
    padding: 10px;
    text-align: center;
    width: 100%;
  }
  &__success {
    border: 2px solid #2da780;
    margin: 20px 0;
    padding: 10px;
    text-align: center;
    width: 100%;
  }
}
</style>
